__webpack_require__.p = "/balatro-joker-tracker/";